import { createAction, props } from '@ngrx/store';
import { CreateWhitelistAddressRequest } from '../models/whitelist-address.model';

// Create Actions
export const createWhitelistAddress = createAction(
  '[WhitelistAddress] Create Whitelist Address',
  props<{ request: CreateWhitelistAddressRequest }>()
);

export const createWhitelistAddressSuccess = createAction(
  '[WhitelistAddress] Create Whitelist Address Success'
);

export const createWhitelistAddressFailure = createAction(
  '[WhitelistAddress] Create Whitelist Address Failure',
  props<{ error: string }>()
);

// Link to Wallet
export const linkWhitelistAddressToWallet = createAction(
  '[WhitelistAddress] Link Whitelist Address To Wallet',
  props<{ walletId: string; whitelistAddressId: string }>()
);

export const linkWhitelistAddressToWalletSuccess = createAction(
  '[WhitelistAddress] Link Whitelist Address To Wallet Success'
);

export const linkWhitelistAddressToWalletFailure = createAction(
  '[WhitelistAddress] Link Whitelist Address To Wallet Failure',
  props<{ error: string }>()
);

// Enable/Disable/Delete Actions
export const enableWhitelistAddress = createAction(
  '[WhitelistAddress] Enable Whitelist Address',
  props<{ addressWhitelistId: string }>()
);

export const enableWhitelistAddressSuccess = createAction(
  '[WhitelistAddress] Enable Whitelist Address Success'
);

export const enableWhitelistAddressFailure = createAction(
  '[WhitelistAddress] Enable Whitelist Address Failure',
  props<{ error: string }>()
);

export const disableWhitelistAddress = createAction(
  '[WhitelistAddress] Disable Whitelist Address',
  props<{ addressWhitelistId: string }>()
);

export const disableWhitelistAddressSuccess = createAction(
  '[WhitelistAddress] Disable Whitelist Address Success'
);

export const disableWhitelistAddressFailure = createAction(
  '[WhitelistAddress] Disable Whitelist Address Failure',
  props<{ error: string }>()
);

export const deleteWhitelistAddress = createAction(
  '[WhitelistAddress] Delete Whitelist Address',
  props<{ addressWhitelistId: string }>()
);

export const deleteWhitelistAddressSuccess = createAction(
  '[WhitelistAddress] Delete Whitelist Address Success'
);

export const deleteWhitelistAddressFailure = createAction(
  '[WhitelistAddress] Delete Whitelist Address Failure',
  props<{ error: string }>()
);

// Reset State
export const resetState = createAction('[WhitelistAddress] Reset State');
